import { EINVOICE_PROVIDER_MODE } from '@/utils/einvoice.enum'
import { BILL_TYPE } from '@/utils/enum'
import { BILL_TYPE_NAME } from '@/utils/enum-name'
import { resolveSaleTypeByBillType } from '@/core/services/store/modules/einvoice/einvoice.contract'

const BILL_TYPE_TO_PROVIDER_MODE = Object.freeze({
  [BILL_TYPE.RETAIL_INVOICE]: EINVOICE_PROVIDER_MODE.FAST_POS,
  [BILL_TYPE.WHOLESALE_INVOICE]: EINVOICE_PROVIDER_MODE.FAST_PORTAL,
  [BILL_TYPE.SHIPPING]: EINVOICE_PROVIDER_MODE.FAST_POS,
})

export function getCanonicalSaleTypeByBillType(billType) {
  return resolveSaleTypeByBillType(billType)
}

export function getProviderModeByBillType(billType) {
  return BILL_TYPE_TO_PROVIDER_MODE[billType] || null
}

export function requireEInvoiceLaneByBillType(billType) {
  const saleType = getCanonicalSaleTypeByBillType(billType)
  const providerMode = getProviderModeByBillType(billType)

  if (!saleType || !providerMode) {
    const error = new Error('Không xác định được lane e-invoice cho loại hóa đơn hiện tại')
    error.code = 'EINVOICE_SALE_TYPE_REQUIRED'
    throw error
  }

  return {
    saleType,
    providerMode,
  }
}

export function getBillTypeDisplayName(billType) {
  return BILL_TYPE_NAME[billType] || null
}

export function resolveEInvoiceDisplayBillTypeContext({
  billType = null,
  saleType = null,
  providerMode = null,
} = {}) {
  if (billType === null || billType === undefined || billType === '') {
    return {
      billType: null,
      billTypeName: null,
      saleType,
      providerMode,
    }
  }

  const lane = requireEInvoiceLaneByBillType(billType)
  const normalizedSaleType = saleType || lane.saleType
  const normalizedProviderMode = providerMode || lane.providerMode
  const saleTypeMatches = !saleType || saleType === lane.saleType
  const providerModeMatches = !providerMode || providerMode === lane.providerMode

  if (!saleTypeMatches || !providerModeMatches) {
    const error = new Error('Loại hóa đơn không khớp lane e-invoice hiện tại')
    error.code = 'EINVOICE_BILL_TYPE_LANE_MISMATCH'
    throw error
  }

  return {
    billType,
    billTypeName: getBillTypeDisplayName(billType),
    saleType: normalizedSaleType,
    providerMode: normalizedProviderMode,
  }
}
